import script from "./KnowledgeBaseMappingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBaseMappingModal.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBaseMappingModal.vue?vue&type=style&index=0&id=ce480ffc&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce480ffc"]])

export default __exports__